<script setup>
import AdvancedMessageManager from '@/views/apps/message/list/AdvancedMessageManager.vue';

definePage({
  meta: {
    action: 'read',
    subject: 'messages',
  },
})
</script>

<template>
  <section>
    <AdvancedMessageManager></AdvancedMessageManager>
  </section>
</template>
